



























































import { Vue, Prop, Component } from 'vue-property-decorator';
import { ReceiptViewModel, BasketViewModel } from '@/types/apiServerContract';
import AnimateValue from '@/core/ui-components/AnimateValue.vue';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';
import NextDelivery from '@/project/product/nextdelivery/NextDelivery.vue';

@Component({
    components: { NextDelivery, AnimateValue, SpinnerOverlay }
})

export default class OrderSummary extends Vue {
    @Prop({
        required: true,
        type: Object
    }) model!: ReceiptViewModel | BasketViewModel;

    @Prop({
        required: false,
        default: true,
        type: Boolean
    }) showPrices!: boolean

    @Prop(Boolean)
    private updateInProgress!: boolean;

    @Prop({ required: false, type: String, default: '', validator: (value: string) => ['', 'basket', 'checkout', 'receipt'].includes(value) })
    private mode!: 'basket' | 'checkout' | 'receipt';

    @Prop({ required: false, default: 'pt-30 px-10 md:px-40 pb-25' })
    wrapClass!: string;

    private get basketMode() : boolean {
        return this.mode === 'basket';
    }

    private get checkoutMode() : boolean {
        return this.mode === 'checkout';
    }
};
